import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

export default function OriginTags({ row }) {
  const chips = [];
  if (row.mergedFromAdvancePaymentIds && row.mergedFromAdvancePaymentIds.length) {
    chips.push(
      <Chip key="from" size="small" color="secondary" variant="outlined" label={`⧉ agrupado de ${row.mergedFromAdvancePaymentIds.map((id) => `#${id}`).join(", ")}`} />
    );
    if (row.autoMerged) chips.push(<Chip key="auto" size="small" variant="outlined" label="⚡ agrupado automaticamente" />);
  }
  if (row.originAdvancePaymentId) {
    chips.push(
      <Chip key="split" size="small" color="warning" variant="outlined" label={`⑂ filho de split de #${row.originAdvancePaymentId}`} />
    );
  }
  if (row.mergedIntoAdvancePaymentId) {
    chips.push(<Chip key="into" size="small" variant="outlined" label={`→ agrupado no #${row.mergedIntoAdvancePaymentId}`} />);
  }
  if (!chips.length) return <span style={{ color: "#9e9e9e" }}>—</span>;
  return (
    <Stack direction="row" spacing={0.5} useFlexGap sx={{ flexWrap: "wrap" }}>
      {chips}
    </Stack>
  );
}
